<template>
    <div>
        <div class="row no-gutters">
            <div class="col-12">
                <h2 class="order-summary__head">
                    {{ getTranslation('licence-configurator', 'order_summary_table_title') }}
                </h2>
            </div>
        </div>

        <div class="custom-table custom-table__stretch">
            <div class="row custom-table__head d-none d-sm-flex">
                <div class="col-4 col-sm"><div class="custom-table__head--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                <div class="col-3 col-sm"><div class="custom-table__head--elem text-sm-center">{{ getTranslation('licence-configurator', 'period') }}</div></div>
                <div class="col-1"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('licence-configurator', 'days') }}</div></div>
                <div class="col-1 col-80"><div class="custom-table__head--elem">{{ getTranslation('licence-configurator', 'licenses') }}</div></div>
                <div class="col-1 col-80"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'price') }}</div></div>
                <div class="col-2 col-80"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'total') }}</div></div>
            </div>

            <template v-for="program in sortedPrograms()" v-if="program.product == product.id && program[licenceType] > 0">
                    <div class="row no-gutters custom-table__body  ">
                    <!--  name-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem">
                            {{ getProgramName(program.id, product.id) }}
                        </div>
                    </div>

                    <!--  period-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'period') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem text-sm-center" >
                            {{ getTranslation('licence-configurator', 'new') }} - {{ formatDateByLang(getFormattedDate(addDaysToToday(program.days !== false ? program.days : 365))) }}
                        </div>
                    </div>

                    <!--  days-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'days') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right">
                        <div class="custom-table__body--elem" >{{ program.days !== false ? program.days : 365 }}</div>
                    </div>

                    <!--  quantity -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'licenses') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>

                    <!--  line price -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">{{ linePrice(program) }}</div>
                    </div>

                    <!--  total price -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">{{ totalPrice(program) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                    </div>
                </template>


            <template v-for="program in sortedProgramsConfig()">
                    <div class="row no-gutters custom-table__body  ">
                    <!--  name-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem" v-html="getProgramName(program.program_id, product.id)" ></div>
                    </div>

                    <!--  period-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'period') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem text-sm-center" v-html="formatDateByLang(program.lease_end) + ' ' + shopConfigOptions.upgradeIcon + ' ' + formatDateByLang(program.lease_end_new)"></div>
                    </div>

                    <!--  days-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'days') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right">
                        <div class="custom-table__body--elem" >{{ program.daysDiff }}</div>
                    </div>

                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'licenses') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem">{{ program.quantity }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem">{{ linePriceConfig(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">{{ totalPriceConfig(program) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                    </div>
                </template>


            <template v-for="program in sortedProgramsPerpetual()" v-if="hasPerpetualUpgrade()">
                <div class="row no-gutters custom-table__body  ">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem">{{ getProgramName(program.id, product.id) }}</div>
                    </div>

                    <!--  period-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'period') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem text-sm-center" >
                            {{ getTranslation('licence-configurator', 'perpetual') }}
                        </div>
                    </div>

                    <!--  days-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'days') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right">
                        <div class="custom-table__body--elem" ></div>
                    </div>


                    <!--  quantity -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'licenses') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>

                    <!--  line price -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">{{ priceFormat(getProgramPrice(program.id, '', licenceType, program.product, 3), true)}}</div>
                    </div>

                    <!--  total price -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">{{ priceFormat(getProgramPrice(program.id, '', licenceType, program.product, program[licenceType] * 3), true) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </div>
            </template>

            <template v-for="program in sortedExistingPrograms()">
                <div class="row no-gutters custom-table__body  ">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem">{{ getProgramName(program.program_id, program.product) }} {{ program.lease_end }}</div>
                    </div>

                    <!--  period-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'period') }}</div></div>
                    <div class="col-8 col-sm">
                        <div class="custom-table__body--elem text-sm-center" >
                            {{ getTranslation('licence-configurator', 'perpetual') }}
                        </div>
                    </div>

                    <!--  days-->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'days') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right">
                        <div class="custom-table__body--elem" ></div>
                    </div>


                    <!--  quantity -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('licence-configurator', 'licenses') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem">{{ program.quantity }}</div>
                    </div>

                    <!--  line price -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-1 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">
                            {{ priceFormat(getProgramPrice(program.program_id, '', licenceType, program.product, 1 * 3), true) }}
                        </div>
                    </div>

                    <!--  total price -->
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right col-80">
                        <div class="custom-table__body--elem custom-table__body--price">
                            {{ priceFormat(getProgramPrice(program.program_id, '', licenceType, program.product, program.quantity * 3), true) }}
                        </div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </div>
            </template>

            <!--  total-->
            <div class="row no-gutters custom-table__body  ">
                <div class="col-4 col-sm-6"><div class="custom-table__title--elem custom-table__title--total" >{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-6 text-sm-right">
                        <div class="custom-table__body--elem custom-table__title--total custom-table__body--price" >{{ priceFormat(getTotalPrice())  }}</div>
                    </div>
                </div>
            </div>
        <br><br>
    </div>

</template>

<script>
    export default {
        methods: {
            sortedExistingPrograms() {
                let self = this;
                let programs = _.filter(this.$store.state.cart.perpetualUpgrade, {product: self.product.id});
                return  _.sortBy(programs, [function(o) { return o.sortOrder; }]).reverse();
            },
            sortedProgramsPerpetual() {
                return  _.sortBy(this.programs, [function(o) { return o.sortOrder; }]).reverse();
            },
            hasPerpetualUpgrade() {
                let self = this;
                let hasUpgrade = false;
                _.forOwn(this.$store.state.cart.programs, function(program) {
                    if (program.perpetual_upgrade && program.product == self.product.id) {
                        hasUpgrade = true;
                    }
                });
                return hasUpgrade;
            },
            sortedProgramsConfig() {
                let self = this;
                let filtered = _.filter(this.$store.state.cart.leaseProlongConfigs, function(l) { return (l.product === self.product.id); });
                if (_.isEmpty(filtered)) {
                    return false;
                }
                return _.orderBy(filtered, ['daysDiff', 'sort_order'], ['desc', 'desc']);
            },
            sortedPrograms() {
                return  _.sortBy(this.programs, [function(o) { return o.sortOrder; }]).reverse();
            },
            quantity(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return 1;
                }
                return _.isNil(program[this.licenceType]) ? 0 : program[this.licenceType]
            },
            linePrice(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, program[this.licenceType]), true)
                }
                return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, 1, false, 0, program.days), true)
            },
            totalPrice(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, program[this.licenceType]), true)
                }
                return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, program[this.licenceType], false, 0, program.days), true)
            },
            linePriceConfig(item) {
                return this.priceFormat(this.getProgramPrice(item.program_id, '', this.licenceType, item.product, 1, false, item.discount, item.daysDiff));
            },
            totalPriceConfig(item) {
                return this.priceFormat(this.getProgramPrice(item.program_id, '', this.licenceType, item.product, item.quantity, false, item.discount, item.daysDiff));
            },
            programName(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return this.getPluralTranslation('cart-vue', 'program_name_with_qty_truss4_plural', program[this.licenceType], {name: program.name});
                }
                let name = this.getProgramName(program.id, this.product.id);
                if (program.days) {
                    name += " " + this.getFormattedDate(this.addDaysToToday(program.days));
                    name +=  " ( " + this.getPluralTranslation('order-content', 'days_with_plural', program.days) +" ) "
                }
                return name;
            },
            addDaysToToday(days) {
                const date = new Date(); // Get today's date
                date.setDate(date.getDate() + days); // Add the specified number of days
                return date; // Returns the new date object
            },
            getFormattedDate(date = false) {
                if (date === false) {
                    date = new Date();
                }
                let year = date.getFullYear();
                // Month is 0-indexed, so add 1
                let month = String(date.getMonth() + 1).padStart(2, '0');
                let day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            getTotalPrice() {
                let self = this;
                let total = 0;
                _.forOwn(this.$store.state.cart.programs, function(program) {
                    if (program.perpetual_upgrade && program.product === self.product.id) {
                        total += self.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity * 3)
                    }
                    if (program.product === self.product.id) {
                        total += self.getProgramPrice(program.id, '', self.licenceType, program.product, program[self.licenceType], false, 0, program.days);
                    }
                });
                _.forOwn(this.sortedProgramsConfig(), function(item) {
                    total += self.getProgramPrice(item.program_id, '', self.licenceType, item.product, item.quantity, false, item.discount, item.daysDiff);
                });

                _.forOwn(this.sortedExistingPrograms(), function(program) {
                    total += self.getProgramPrice(program.program_id, '', 'cloud_time_quantity', program.product, program.quantity * 3)
                });
                return total;
            }
        },
        beforeMount() {
            let self = this;
            this.programs = _.filter(this.programs, function(l) { return (l.product === self.product.id); });
            this.existingPrograms = _.filter(this.existingPrograms, {product: self.product.id});
        },
        computed: {

        },
        data() {
            return {
                programs: this.$store.state.cart.programs,
                licenceType: this.getQtyName('lease', 'cloud'),
                shopConfigOptions: window.shopConfigOptions,
                existingPrograms: this.$store.state.cart.perpetualUpgrade,
            };
        },
        props: {
            product: Object,
            translate: String
        }
    }
</script>
